import { Box } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import { abbreviatedNumber } from 'src/pages/Yearbooks/presentation/components/Charts/utils';

import { CHART_COLORS } from '../../../constants';

interface PieChartProps {
  series: number[];
  categories: string[];
  height?: number;
  formatter?: (value: number) => string;
}

export default function PieChart({
  series,
  categories,
  height = 300,
  formatter,
}: PieChartProps) {
  const total = series.reduce((sum, v) => sum + v, 0);

  function defaultFormatter(value: number): string {
    const pct = ((value / (total || 1)) * 100).toFixed(2);
    return `${abbreviatedNumber(value)} (${pct}%)`;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <ReactApexChart
        type="donut"
        series={series}
        height={height}
        width="100%"
        options={{
          chart: {
            background: 'transparent',
            toolbar: { show: false },
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 500,
            },
          },
          labels: categories,
          tooltip: {
            theme: 'dark',
            y: { formatter: formatter ?? defaultFormatter },
          },
          colors: CHART_COLORS,
          dataLabels: { enabled: false },
          legend: { show: false },
          grid: { show: false },
          plotOptions: {
            pie: {
              donut: {
                size: '65%',
              },
            },
          },
          responsive: [
            {
              breakpoint: 600,
              options: { chart: { animations: { enabled: false } } },
            },
          ],
        }}
      />
    </Box>
  );
}
